<div class="container" *transloco="let t">
  <app-header [title]="t('AUDIT-SUMMARY-PAGE.HEADER')"></app-header>
  <app-main-card [audit]="audit"></app-main-card>
  <app-distribution-circle [data]="questionList"></app-distribution-circle>
  <app-navigation-box [rightText]="t('AUDIT-SUMMARY-PAGE.BUTTON')" [leftIsVisible]="false" [withIcon]="false" (rightIsPressed)="navigate()"></app-navigation-box>
</div>

